import React from 'react';

import { Route, Switch, Redirect } from 'react-router-dom';

import QueuedList from './List';
import QueuedDetail from 'modules/shipper-order/detail';

import {
  featurePreferenceToggle,
  FLEET_PROCESS_HIDE_QUEUED_ORDERS,
} from 'modules/preferences-manager/preferences';

const RedirectToDispatching = () => <Redirect to="/fleet/dispatching" />;

const Queued = ({ match }) => {
  return (
    <>
      <Switch>
        <Route
          path={`${match?.url}`}
          exact
          component={
            featurePreferenceToggle(FLEET_PROCESS_HIDE_QUEUED_ORDERS)
              ? RedirectToDispatching
              : QueuedList
          }
        />
        <Route path={`${match?.url}/:id`} component={QueuedDetail} />
      </Switch>
    </>
  );
};

export default Queued;
